import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetUberOrganizationSettingDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useUberOrganizationSetting = () => {
  const [getUberOrgSetting, { data, loading, called }] = useLazyQuery(
    GetUberOrganizationSettingDocument,
    {
      fetchPolicy: 'network-only',
    },
  );
  const enable = data ? getMe(data)?.organization.uberOrganizationSetting?.enable : false;

  useEffect(() => {
    getUberOrgSetting();
  }, [getUberOrgSetting]);

  return {
    loading: loading || !called,
    enable: !!enable,
  };
};
